<script lang="ts">
    import type { ITrxTpv } from '../../order'
    import Icon from '@iconify/svelte'

    import { cardData } from 'wdom/utils/credit_card'
    import type { ICardData } from 'wdom/utils/credit_card'

    import Date from 'hydria/components/Date.svelte'

    interface Props {
        trx: ITrxTpv
    }

    let { trx }: Props = $props()

    let expandTransaction = $state(false)
    let expandQuery = $state(false)

    let cardMeta: ICardData | undefined = $derived.by(() => {
        let fakeNum = trx.data.tpv.card_number_first_digits
        // probably mastercards, but not necessarily.. better not to falsely claim it's MC when it might not be, keep commented
        // if (fakeNum == '22') fakeNum += '21'
        // else if (fakeNum == '27') fakeNum += '20'
        fakeNum = fakeNum.padEnd(trx.data.tpv.card_number_total_digits - fakeNum.length - trx.data.tpv.card_number_last_digits.length, '0') + trx.data.tpv.card_number_last_digits
        let meta = cardData(fakeNum)
        if (meta == null && trx.data.tpv.card_number_total_digits == 16) {
            meta = { tag: '-', text: '', innRanges: [], lengths: [16], cvdLength: 3, masks: ['0000 0000 0000 0000'] }
        }
        return meta
    })

    let cardNumber: string | undefined = $derived.by(() => {
        let cardNumber: string | undefined = undefined
        if (cardMeta) {
            let i = cardMeta.lengths.indexOf(trx.data.tpv.card_number_total_digits)
            if (i >= 0) {
                cardNumber = cardMeta.masks[i].replaceAll('0', 'X')
                for (const c of trx.data.tpv.card_number_first_digits) {
                    cardNumber = cardNumber.replace('X', c)
                }
                for (const c of trx.data.tpv.card_number_last_digits.split('').reverse()) {
                    cardNumber = cardNumber.replace(/(.*)X/, `$1${c}`)
                }
            }
        }
        if (!cardNumber) {
            cardNumber = trx.data.tpv.card_number_first_digits + 'X'.padEnd(trx.data.tpv.card_number_total_digits - trx.data.tpv.card_number_first_digits.length - trx.data.tpv.card_number_last_digits.length, 'X') + trx.data.tpv.card_number_last_digits
        }

        return cardNumber
    })
</script>

<h4>Carte de crédit / {trx.data.processor[0].toLocaleUpperCase() + trx.data.processor.slice(1)}</h4>

<table class="table">
    <caption>Transaction <button type="button" class="btn btn-sm btn-outline-secondary float-end" class:active={expandTransaction} onclick={() => (expandTransaction = !expandTransaction)}><Icon inline icon="fa:arrows-v" /></button></caption>
    <tbody>
        <tr><th>Succès</th><td>{trx.success ? 'Oui' : 'Non'}</td></tr>
        <tr><th>Statut</th><td>{trx.status}</td></tr>
        {#if expandTransaction}
            <tr><th>Méthode</th><td>{trx.payment_method}</td></tr>
            <tr><th>Processor</th><td>{trx.data.processor}</td></tr>
            <tr><th>Date</th><td><Date value={trx.stamp} format="h-table-s" /></td></tr>
            <tr><th>Address IP</th><td>{trx.ip_address}</td></tr>
            <tr><th>ID</th><td>{trx.id}</td></tr>
        {/if}
    </tbody>
</table>

<table class="table">
    <caption>Requête <button type="button" class="btn btn-sm btn-outline-secondary float-end" class:active={expandQuery} onclick={() => (expandQuery = !expandQuery)}><Icon inline icon="fa:arrows-v" /></button></caption>
    <tbody>
        <tr><th>Nom sur la carte</th><td>{trx.data.tpv.name_on_card}</td></tr>
        <tr><th>Numéro de carte</th><td>{cardNumber}</td></tr>
        <tr><th>Expiration</th><td>{trx.data.tpv.expiration_month} / {trx.data.tpv.expiration_year}</td></tr>
        {#if expandQuery}
            <tr><th>Montant</th><td>{trx.data.tpv.amount}</td></tr>
            <tr><th>Date</th><td><Date value={trx.data.tpv.stamp} format="h-table" /></td></tr>
        {/if}
    </tbody>
</table>
